import { render } from "./ProjectLink.vue?vue&type=template&id=283fb8dc&scoped=true"
import script from "./ProjectLink.vue?vue&type=script&lang=js"
export * from "./ProjectLink.vue?vue&type=script&lang=js"

import "./ProjectLink.vue?vue&type=style&index=0&id=283fb8dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283fb8dc"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
